export function setUserFormLocaleCZ(state, payload) {
  switch (payload) {
    case('cz'):
      const addressesCz = [
        { city: 'Prague', address: 'Vaclavske namesti 5', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Na Prikope 22', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Narodni 135/14', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Vinohradska 40', zip: '120 00', state: 'PR' },
        { city: 'Prague', address: 'Zizkovska 1228/10', zip: '130 00', state: 'PR' },
        { city: 'Prague', address: 'Na Florenci 3', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Rytirska 29', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Wenceslas Square 48', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Vaclavske namesti 57', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Opletalova 19', zip: '110 00', state: 'PR' },
        { city: 'Prague', address: 'Narodni trida 388/5', zip: '110 00', state: 'PR' },
        { city: 'Brno', address: 'namesti Svobody 17', zip: '602 00', state: 'JM' },
        { city: 'Ostrava', address: 'Masarykova 212', zip: '702 00', state: 'MO' },
        { city: 'Plzen', address: 'namesti Republiky 33', zip: '301 00', state: 'PL' },
        { city: 'Liberec', address: 'namesti Dr. E. Benese 14', zip: '460 01', state: 'LI' },
        { city: 'Olomouc', address: 'Denisova 4', zip: '772 00', state: 'MO' },
        { city: 'Ceske Budejovice', address: 'Namesti Premysla Otakara II. 1', zip: '370 01', state: 'JC' },
        { city: 'Hradec Kralove', address: 'namesti Generala Klapalka 42', zip: '500 03', state: 'KR' },
        { city: 'Usti nad Labem', address: 'Mirove namesti 1', zip: '400 01', state: 'US' },
        { city: 'Pardubice', address: 'namesti Republiky 4', zip: '530 02', state: 'PA' },
        { city: 'Havirov', address: 'U Hubertuse 1', zip: '736 01', state: 'MO' },
        { city: 'Zlin', address: 'namesti Miru 21', zip: '760 01', state: 'ZL' },
        { city: 'Kladno', address: 'namesti starosty Pavla 1', zip: '272 01', state: 'ST' },
        { city: 'Most', address: 'T.G.Masaryka 379', zip: '434 01', state: 'US' },
        { city: 'Karvina', address: 'namesti Dr. E. Benese 1260', zip: '733 01', state: 'MO' },
        { city: 'Frydek-Mistek', address: 'Mirove namesti 3', zip: '738 01', state: 'MO' },
        { city: 'Opava', address: 'namesti Krale Jiriho z Podebrad 6', zip: '746 01', state: 'MO' },
        { city: 'Teplice', address: 'Masarykovo namesti 6', zip: '415 01', state: 'US' },
        { city: 'Decin', address: 'Masarykovo namesti 1', zip: '405 02', state: 'US' },
        { city: 'Karlovy Vary', address: 'namesti Republiky 2', zip: '360 01', state: 'KA' },
      ];

      const randomIndex = Math.floor(Math.random() * addressesCz.length);
      const randomAddress = addressesCz[randomIndex];

      state.userForm.city = randomAddress.city;
      state.userForm.zip = randomAddress.zip;
      state.userForm.address = randomAddress.address;
      state.userForm.state = randomAddress.state;

      break;
  }
}
